import { Button } from "@mui/material";
import styled from "styled-components";

export const ContainerIncidence = styled.div`
    height: 100%;
    width: 100%;

    padding: 30px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const Total = styled.div`
    width: 250px;
    height: 80px;
    background-color:#F09999 ;
    margin: 20px;
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    border-radius: 12px;

    align-self: flex-start;

    font-size: 1.3rem;

    .numero {
        font-weight: bold;
        font-size: 1.7;
    }
`;

export const Btn = styled(Button)`
    background-color: #F09999 !important;

    &:hover {
        background-color: #f0b3b3 !important;
    }

    
    




`